import React, { Component } from 'react';

import Actions from './../flux/Actions';
import { __ } from './../Translator';
import Footer from "../components/Footer";
import StepIndicator from "../components/StepIndicator";
import Header from "../components/Header";
import InlineSvg from "../InlineSvg";

import './ProductSelection.css';

import ProductSuitIcon from './../img/suit.svg';
import ProductTrousersIcon from './../img/pants2.svg';
import ProductJacketIcon from './../img/jackets2.svg';
import ProductBootsIcon from './../img/boots.svg';
import AppStore from "../flux/AppStore";
import AppActions from "../flux/AppActions";

class ProductSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      category: null,
    };

    this.categories = {
      SUIT: 'SUIT',
      JACKET: 'JACKET',
      TROUSERS: 'TROUSERS',
      BOOTS: 'BOOTS',
    };

    this.props.navigation.onBack(() => {
      this.props.navigation.navigate('homepage');
    });

    this.onProductCategorySet = this.onProductCategorySet.bind(this);
    this.onCustomProductChange = this.onCustomProductChange.bind(this);
  }

  componentDidMount() {
    // Actions.getProducts();

    this.setCategoryState(AppStore.getProductCategory());

    AppStore.events.setProductCategory.addListener(this.onProductCategorySet);
    AppStore.events.initCustomProduct.addListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductChange);
  }

  componentWillUnmount() {
    AppStore.events.setProductCategory.removeListener(this.onProductCategorySet);
    AppStore.events.initCustomProduct.removeListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductChange);
  }

  onProductCategorySet(category) {
    this.setCategoryState(category)
  }

  onCustomProductChange() {
    this.setCategoryState(AppStore.getCustomProduct().product.category);
  }

  onProductClick(category) {
    AppActions.setProductCategory(category);
    this.props.navigation.navigate('modelSelection');
  }

  setCategoryState(category) {
    this.setState({ category });
  }

  render() {
    return (
      <div className="container-product-selection">
        <Header
          title={__('Configurator')}
        />

        <Footer navigation={this.props.navigation} showPrice={false} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2">
              <div className="main__hero">
                <h1 className="hero__title">{__('Select your product')}</h1>
                <div className="hero__text">
                  <p>{__('Please select the product to be customized')}</p>
                </div>
              </div>
              <div className="productSelection fix-100">
                <div className="row">

                  <div className="col-md-4">
                    <div className="productSelection__productContainer fix-1"
                         onClick={() => this.onProductClick(this.categories.SUIT)}
                    >
                      <InlineSvg className="productSelection__product m--product" svg={ProductSuitIcon}/>
                      <div className="mainModel__name">
                        <div className="text-cell">{__('SUIT')}</div>
                      </div>
                      <div className="productModel__select">
                        <button className="btn btn-primary">
                          {__('Select')}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="productSelection__productContainer fix-2"
                      onClick={() => this.onProductClick(this.categories.JACKET)}
                    >
                      <InlineSvg className="productSelection__product m--jacket m--shorter" svg={ProductJacketIcon}/>

                      <div className="mainModel__name">
                        <div className="text-cell">{__('JACKET')}</div>
                      </div>
                      <div className="productModel__select">
                        <button className="btn btn-primary">{__('Select')}</button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="productSelection__productContainer fix-3"
                      onClick={() => {this.onProductClick(this.categories.TROUSERS);}}
                    >
                      <InlineSvg className="productSelection__product m--trousers m--shorter" svg={ProductTrousersIcon}/>
                      <div className="mainModel__name">
                        <div className="text-cell">{__('TROUSERS')}</div>
                      </div>
                      <div className="productModel__select">
                        <button className="btn btn-primary">{__('Select')}</button>
                      </div>
                    </div>
                  </div>
                  {/*
                  <div className="col-md-3">
                    <div className="productSelection__productContainer fix-3"
                         onClick={() => {this.onProductClick(this.categories.BOOTS);}}
                    >
                      <InlineSvg className="productSelection__product m--trousers m--shorter" svg={ProductBootsIcon}/>
                      <div className="mainModel__name">
                        <div className="text-cell">{__('BOOTS')}</div>
                      </div>
                      <div className="productModel__select">
                        <button className="btn btn-primary">{__('Select')}</button>
                      </div>
                    </div>
                  </div>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductSelection.defaultProps = {
  onProductClick: console.log,

};

export default ProductSelection;



// WEBPACK FOOTER //
// ./src/screens/ProductSelection.js